<div class="outer-container">
    <div class="success-header-container">
        <img class="success-header" src="./images/success-header.svg">
        <img class="success" src="./images/success.svg">
    </div>
    <div class="success-content-container">
        <div class="success-heading">{{successData.heading | translate}}</div>
        <div class="success-content">{{successData.content | translate}}</div>
        <div class="button-container col-5">
        <button class="primary-button cursor-pointer" (click)="buttonClick()">{{successData.btnText |
            translate}}</button>
        </div>
    </div>
</div>